import React from "react";
import { faComment } from "web-fortawesome/npm/pro-light";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IPresenceIconProps } from "./IPresenceIconProps";

/**
 * Presence Icon: Chat
 * @param props - props from interface IPresenceIconProps
 * @returns - the chat icon
 */
export const PresenceIconChat = (props: IPresenceIconProps): React.ReactElement => {
	return (
		<FontAwesomeIcon
			className={props.className}
			icon={faComment}
			fontSize={props.fontSize ?? 16}
			color={props.color ? props.color : `var(--presence-icon-type-${props.type ?? "free"})`}
		/>
	);
};
